module.exports = __webpack_public_path__ + "static/img/screen-print-example-2.3a96ed9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/customisation/screen-print-example-2.png
// module id = SFnx
// module chunks = 1